import styles from './BotHead.module.scss';

const ChatbotHead = () => {
  return (
    <div className={styles.ChatbotName}>
      <div className={styles.inner}>
        <div className={styles.ico}></div>
        <span>숲덕이</span>
      </div>
    </div>
  );
};

export default ChatbotHead;
